function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg185Gibraltar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 341.337,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "332.8,219.64 332.8,194.04 341.334,194.04 341.334,176.973 324.267,176.973    324.267,185.507 307.2,185.507 307.2,176.973 290.134,176.973 290.134,194.04 298.667,194.04 298.667,219.64 281.6,219.64    281.6,159.908 290.134,159.908 290.134,142.841 273.066,142.841 273.066,151.373 264.534,151.373 264.534,142.841 247.466,142.841    247.466,151.373 238.934,151.373 238.934,142.841 221.866,142.841 221.866,159.908 230.4,159.908 230.4,219.64 213.333,219.64    213.333,194.04 221.866,194.04 221.866,176.973 204.8,176.973 204.8,185.507 187.733,185.507 187.733,176.973 170.666,176.973    170.666,194.04 179.199,194.04 179.199,219.64 162.133,219.64 162.133,287.908 349.867,287.908 349.867,219.64  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,279.374c-14.138,0-25.6,11.462-25.6,25.6c0,11.145,7.125,20.624,17.066,24.137v35.596h-25.6  v34.134h42.667v-69.73c9.942-3.514,17.066-12.993,17.066-24.137C281.6,290.836,270.138,279.374,256,279.374z M256,313.508  c-4.714,0-8.534-3.821-8.534-8.534c0-4.714,3.82-8.534,8.534-8.534c4.713,0,8.534,3.82,8.534,8.534  C264.534,309.687,260.713,313.508,256,313.508z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg185Gibraltar);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };